class Bytes {
  readonly MB = (mb: number) => mb * 1024 * 1024
}

export default new Bytes
